import { render } from "./BasePartitionMetric.vue?vue&type=template&id=2d36a55e"
import script from "./BasePartitionMetric.vue?vue&type=script&lang=js"
export * from "./BasePartitionMetric.vue?vue&type=script&lang=js"

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BasePartitionMetric.vue"]])

export default __exports__